import WidgetBase from "../common/widgetBase";
import Alias from "components/controls/alias";
import Message from "../common/message";
import { Converter } from "../../workspace/converter";
import EnvelopeControls from "../common/envelopeControls";

export default class MessageNode extends WidgetBase {
  getBoundAlias() {
    return Converter.getComponentPortValueData(this.props.data.component, "message");
  }

  // The bound message envelope, or null when no alias is bound, the value is
  // not loaded yet, or it is not a message-typed object.
  getEnvelopeValue() {
    const alias = this.getBoundAlias();
    if ( !alias || !this.context ) return null;
    const value = this.context.getSessionData(alias);
    return value && value.type === "message" ? value : null;
  }

  renderHeaderAlias() {
    const alias = this.getBoundAlias();
    if ( !alias ) return null;
    return <Alias value={alias} variant="chip" />;
  }

  renderHeaderActions() {
    return (
      <EnvelopeControls
        alias={this.getBoundAlias()}
        value={this.getEnvelopeValue()}
        shellInterface={this.props.data.shellInterface}
        sessionManager={this.context}
      />
    );
  }

  // Where a `file` content block's bytes come from — the same {api, revisionId, sessionId} triple
  // thread/index.js's fileContext() resolves for the thread widget, guarded the same way: a
  // shellInterface or session double that doesn't expose the full seam (a test fixture, an older
  // embedding host) degrades to undefined instead of throwing.
  fileContext() {
    const session = this.context && this.context.session;
    const shellInterface = this.props.data && this.props.data.shellInterface;
    if ( !session || !shellInterface || !shellInterface.getApp || !shellInterface.getRevision ) return undefined;
    const app = shellInterface.getApp();
    const revision = shellInterface.getRevision();
    if ( !app || !app.api || !revision || !revision["id"] ) return undefined;
    return { api: app.api, revisionId: revision["id"], sessionId: session.id };
  }

  renderBody() {
    const [messageValue, notice] = this.loadObjectValue(
      this.props.data.component, "message", "message");
    if ( notice ) return this.renderNotice(notice);

    const contentView = Converter.getComponentPortValueData(this.props.data.component, "content_view");

    return (
      <Message
        value={messageValue}
        contentView={contentView}
        fileContext={this.fileContext()}
      />
    );
  }
}
